import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HttpUrlEncodingCodec } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { AppComponent } from "./app.component";
import { MapComponent } from "./map/map.component";
import { ContactComponent } from "./contact/contact.component";
import { ToolbarComponent } from "./toolbar/toolbar.component";
import { MapService } from "./map.service";
import { Http } from "@angular/http";
import { PortService } from "./port/port.service";
import { OffrecommercialeService } from "./offrecommerciale/offrecommerciale.service";
import { GeocodingService } from "./geocoding.service";

import {
  FormsModule,
  ReactiveFormsModule,
  NgSelectOption
} from "@angular/forms";
import { AccordionModule } from "primeng/accordion";
import { MenuItem } from "primeng/api";
import { OrderListModule } from "primeng/primeng";
import { SidebarModule } from "primeng/sidebar";
import { ChartModule, CalendarModule, SharedModule } from "primeng/primeng";
import { CheckboxModule } from "primeng/checkbox";
import { PanelModule } from "primeng/panel";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CardModule } from "primeng/card";
import { DialogModule } from "primeng/dialog";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { DataListModule } from "primeng/datalist";
import "leaflet";
import "leaflet.vectorgrid";
import "leaflet-sidebar-v2";
import { MessageService } from "primeng/components/common/messageservice";
import { HttpModule } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MatAutocompleteModule } from "@angular/material";
import { SimpleSearchComponent } from "./offrecommerciale/simplesearch/simplesearch.component";
import { AdvanceSearchComponent } from "./offrecommerciale/advancesearch/advancesearch.component";
import { OffreCommercialeSearchComponent } from "./offrecommerciale/offreCommercialeSearch.component";
import { DetailOffreCommercialeComponent } from "./offrecommerciale/detailoffrecommerciale.component";
//import { NgSelectizeModule } from "ng-selectize";
import { DeviceDetectorModule } from "ngx-device-detector";
import { ContactService } from "./contact/contact.service";
import { CommaSplitPipe } from "./common/commaSplit.pipe";
/*
@Internationnalisation export value 
*/
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MapComponent,
    AppComponent,
    ContactComponent,
    ToolbarComponent,
    OffreCommercialeSearchComponent,
    SimpleSearchComponent,
    AdvanceSearchComponent,
    DetailOffreCommercialeComponent,
    CommaSplitPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    MatButtonModule,
    MessagesModule,
    MessageModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatSidenavModule,
    BrowserModule,
    FormsModule,
    OrderListModule,
    SidebarModule,
    CardModule,
    ChartModule,
    DialogModule,
    AccordionModule,
    CalendarModule,
    AutoCompleteModule,
    DataListModule,
    CheckboxModule,
    PanelModule,
    SharedModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatSnackBarModule,
    MatAutocompleteModule,
    DeviceDetectorModule.forRoot()
    // NgSelectizeModule
  ],
  providers: [
    MapService,
    GeocodingService,
    ToolbarComponent,
    MessageService,
    OffrecommercialeService,
    PortService,
    ContactService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/app.module.ts